class LoadMoreLinkCards {
	constructor(block) {
		this.block = block;
		this.cards = Array.from(block.querySelectorAll('.js-link-card'));
		this.button = block.querySelector('.block-link-cards__load-more');
		this.cardsPerPage = 6;
		this.currentCount = this.cardsPerPage;

		// Do not run on carousel blocks (outer wrapper has .block-link-cards but contains carousel container)
		if (block.classList.contains('block-link-cards--carousel') || block.querySelector('.block-link-cards__carousel-container')) {
			return;
		}

		this.init();
	}

	init() {
		this.hideExtraCards();
		this.bindEvents();

		if (this.cards.length <= this.cardsPerPage) {
			this.cards.forEach(card => card.classList.add('is-visible', 'no-transition'));
			if (this.button) this.button.style.display = 'none';
		}
	}

	hideExtraCards() {
		this.cards.forEach((card, index) => {
			if (index < this.cardsPerPage) {
				card.classList.add('is-visible', 'no-transition'); 
			} else {
				card.classList.add('is-hidden');
			}
		});
	}

	bindEvents() {
		if (!this.button) return;
		this.button.addEventListener('click', () => this.loadMore());
	}

	loadMore() {
		const nextCards = this.cards.slice(this.currentCount, this.currentCount + this.cardsPerPage);

		nextCards.forEach(card => {
			card.classList.remove('is-hidden');
			card.classList.add('no-transition');
		});

		requestAnimationFrame(() => {
			nextCards.forEach(card => {
				card.classList.remove('no-transition');
				card.classList.add('is-visible');
			});
		});

		this.currentCount += this.cardsPerPage;

		if (this.currentCount >= this.cards.length) {
			this.button.style.display = 'none';
		}
	}
}

export default LoadMoreLinkCards;
